import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { getLocaleString } from "lib/localization/vendor";
import { Icon as IconStyle, Fill, Stroke, Style, Text } from "ol/style";
import { assetURL } from "lib/utilities/asset";

import { wordWrapString } from 'lib/utilities/misc';

export default function StyleAnnotationFeatureStreetView(feature: Feature<Geometry>) {
	const styles:any = [];
	
	styles.push(
		new Style({
			image: new IconStyle({
				anchor: [0.5, 0.5],
				scale: 0.1,
				displacement: [0, 20],
				src: assetURL('assets/images/streetviewpin.png')
			})
		})
	);
	
	return styles;
}
